/**
 * The guard itself: true only in a browser. Shared utils use this before
 * touching any browser global, so server render never throws.
 */
// eslint-disable-next-line no-restricted-globals -- this expression is the typeof-window guard
export default !!(typeof window !== 'undefined' && window.document && window.document.createElement)
